export default __webpack_public_path__ + "static/media/emergenciaBlanco.9a9c880d.svg";